export default __webpack_public_path__ + "static/media/print.1fe8bd63.svg";